import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  Platform,
  KeyboardAvoidingView,
  View,
  Modal,
} from 'react-native';
import {
  Button, Text, CheckBox, Tooltip,
} from 'react-native-elements';
import { Formik } from 'formik';
// import { object as yupObject } from 'yup';
import Breadcrumb from '../../../../vendor/react-native-breadcrumb';
import { translate } from '../../../locales/i18n';
import styles from '../../../styles';
import stylesPublisher from '../../../styles/create';
// import {
//   // appNameValidation,
//   // appDescValidation,
// } from '../../../modules/validation/App';
import AppBadge from '../../apps/AppBadge';
import App from '../../../modules/data/App';
import ExpandableList from '../../misc/ExpandableList';

// const validationSchema = yupObject().shape({
//   // appName: appNameValidation,
//   // appDesc: appDescValidation,
// });

class PublisherAppFormReview extends React.Component {
  static getDerivedStateFromProps(props, _state) {
    return {
      promoted: (props.app && props.app.data && props.app.data.promoted) || false,
    };
  }

  constructor(props, context) {
    super(props, context);

    this.handleCancel = this.handleCancel.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleDeleteReal = this.handleDeleteReal.bind(this);
    this.handlePreview = this.handlePreview.bind(this);
    this.handlePublish = this.handlePublish.bind(this);

    const { app } = this.props;
    this.state = {
      promoted: (app && app.data && app.data.promoted) || false,
      isDeleting: false,
    };
  }

  handleCancel() {
    const { onCancel } = this.props;

    onCancel();
  }

  handleBack(values) {
    const { onSave, onPageSwitch } = this.props;

    onSave(values);
    onPageSwitch(5);
  }

  handleNext(values, formikBag) {
    const {
      onSave,
      history,
      getAnalyticsService,
    } = this.props;

    formikBag.setSubmitting(true);
    onSave(values)
      .then((err) => {
        if (err !== null) {
          getAnalyticsService().report.event('page6SaveError', 'create');
          formikBag.setStatus(err);
        } else {
          getAnalyticsService().report.event('page6SaveSuccess', 'create');
        }
        history.push('/my-ai-agents');
      });
  }

  handleDelete() {
    this.setState({ isDeleting: true });
  }

  handleDeleteReal() {
    const {
      app,
      onCancel,
      onDelete,
      getAnalyticsService,
    } = this.props;

    console.log('deleting...');
    getAnalyticsService().report.event('page6DeleteAttempt', 'create');

    onDelete(app).then(() => {
      console.log('deleted.');
      getAnalyticsService().report.event('page6DeleteSuccess', 'create');
      onCancel();
    });
  }

  handlePreview(values) {
    const {
      onSave, onSavePreview, history, app,
      getAnalyticsService,
    } = this.props;

    getAnalyticsService().report.event('page6PreviewAttempt', 'create');

    // TODO(clairbee): display progress
    // formikBag.setSubmitting(true);
    onSave(values)
      .then((err) => {
        if (err === null) {
          onSavePreview(app.data.uuid)
            .then((err2) => {
              if (err2 === null) {
                getAnalyticsService().report.event('page6PreviewSuccess', 'create');

                // Proceed to the app info page (AppInfo)
                history.push(`/ai-agent/${app.data.uuid}`);

                // Proceed to the app playback page (AppView)
                // history.push(`/ai-agent/online/${app.data.uuid}`);
              }
            });
        }
      });
    // TODO(clairbee): display progress
    // formikBag.setSubmitting(false);
  }

  handlePublish(values) {
    const {
      onSave, onSavePublish, history, app,
      getAnalyticsService,
    } = this.props;

    getAnalyticsService().report.event('page6PublishAttempt', 'create');

    // TODO(clairbee): display progress
    // formikBag.setSubmitting(true);
    onSave(values)
      .then((err) => {
        if (err === null) {
          onSavePublish(app.data.uuid)
            .then((err2) => {
              if (err2 === null) {
                getAnalyticsService().report.event('page6PublishSuccess', 'create');

                // Proceed to the app info page (AppInfo)
                history.push('/appadded');
              }
            });
        }
      });
    // TODO(clairbee): display progress
    // formikBag.setSubmitting(false);
  }

  renderForm = ({
    isValid,
    values,
    handleSubmit,
    setFieldValue,
    // touched,
    // errors,
    setFieldTouched,
    isSubmitting,
    status,
  }) => {
    const { onPageSwitch, onDelete, direction } = this.props;
    const { promoted, isDeleting } = this.state;
    const { app } = values;

    const issues = app.getIssues();
    const hasIssues = issues.length > 0;

    return (
      <>
        <Breadcrumb
          entities={[
            translate('create_app_app'),
            translate('create_app_guide'),
            translate('create_app_endpoints'),
            translate('create_app_payment'),
            translate('create_app_links'),
            translate('create_app_review'),
          ]}
          isTouchable
          flowDepth={5}
          onCrumbPress={(index) => onPageSwitch(index + 1)}
          borderRadius={3}
          firstCrumbStyle={stylesPublisher.publisherAppEdit.firstCrumbStyle}
          crumbsContainerStyle={direction === 'column' ? stylesPublisher.publisherAppEdit.crumbsContainerStyle : stylesPublisher.publisherAppEdit.crumbsContainerStyleLandscape}
        />
        {/* Page 5: Review/Promotion */}
        <KeyboardAvoidingView
          style={[
            styles.view.form,
            {
              backgroundColor: 'white',
              width: '100%',
              padding: 0,
              margin: 0,
              alignItems: 'center',
              justifyContent: 'space-evenly',
            },
          ]}
          // behavior={Platform.OS === 'ios' ? 'padding' : undefined}
          behavior="padding"
        >
          <View style={styles.form.containerInputs}>
            {status !== undefined && (
              <Text
                style={{
                  color: 'red',
                }}
              >
                {status}
              </Text>
            )}

            {hasIssues ? (
              <>
                <Text
                  style={{
                    width: '80%',
                    marginTop: 30,
                    marginBottom: 10,
                    textAlign: 'center',
                    color: '#4E4B66',
                    fontFamily: styles.primaryFont400,
                    fontWeight: '400',
                    fontSize: 18,
                    lineHeight: 34,
                  }}
                >
                  {translate('issues')}
                </Text>
                <ExpandableList
                  style={{
                    flex: 1,
                    width: '100%',
                    marginVertical: 10,
                    alignSelf: 'center',
                  }}
                  itemBackground="#B51F781A"
                  items={issues}
                />
              </>
            ) : (
              <>
                <View
                  style={{
                    flexDirection: 'row',
                    maxWidth: '80%',
                    width: '80%',
                    minWidth: 310,
                    justifyContent: 'center',
                    // borderColor: 'yellow',
                    // borderWidth: 5,
                  }}
                >
                  <View
                    style={{
                      flex: 1,
                      flexDirection: 'row',
                      justifyContent: 'center',
                      maxWidth: 500,
                      // borderColor: 'red',
                      // borderWidth: 5,
                    }}
                  >
                    <AppBadge
                      style={{
                        flex: 1,
                        minWidth: 310,
                        maxWidth: 500,
                      }}
                      data={values.app.data}
                      icons
                    />
                  </View>
                </View>

                <View>
                  {values.app.data.type > 0 && (
                    <>
                      <CheckBox
                        center
                        title={translate('app_promote')}
                        onPress={() => {
                          const p = !promoted;
                          if (app && app.data) {
                            app.data.promoted = p;
                          }
                          this.setState({ promoted: p });
                          setFieldValue('promoted', p);
                          setFieldTouched('promoted');
                        }}
                        // checkedIcon="dot-circle-o"
                        // uncheckedIcon="circle-o"
                        checked={promoted}
                      />
                      {Platform.OS !== 'web' ? (
                        <Tooltip
                          // style={{ height: 'auto' }}
                          // FIXME(clairbee): fix tooltip size
                          height={200}
                          containerStyle={{ /* flex: 1, flexWrap: 'wrap', */ alignSelf: 'baseline' }}
                          popover={(
                            <Text style={{ flex: 1 }}>
                              {translate('app_promote_comment1')}
                              {translate('app_promote_comment2')}
                            </Text>
                          )}
                        >
                          <Text
                            style={{
                              color: styles.primaryColor,
                              textAlign: 'center',
                            }}
                            textDecorationLine="underline"
                          >
                            {translate('app_promote_prompt')}
                          </Text>
                        </Tooltip>
                      ) : (
                        <>
                          <Text>
                            {translate('app_promote_comment1')}
                          </Text>
                          <Text>
                            {translate('app_promote_comment2')}
                          </Text>
                        </>
                      )}
                    </>
                  )}
                </View>
              </>
            )}
          </View>

          <View style={styles.form.containerButtons}>
            <Button
              title={translate('button_cancel')}
              containerStyle={styles.button.secondaryContainer}
              buttonStyle={styles.button.secondary}
              disabledStyle={styles.button.secondaryDisabled}
              titleStyle={styles.button.secondaryTitle}
              disabledTitleStyle={styles.button.secondaryTitleDisabled}
              onPress={this.handleCancel}
            />
            <Button
              title={translate('button_prev')}
              containerStyle={styles.button.primaryContainer}
              buttonStyle={styles.button.primary}
              disabledStyle={styles.button.primaryDisabled}
              titleStyle={styles.button.primaryTitle}
              disabledTitleStyle={styles.button.primaryTitleDisabled}
              onPress={() => this.handleBack(values)}
              disabled={!isValid || isSubmitting}
              loading={isSubmitting}
              loadingProps={{ size: 'small', color: 'white' }}
            />
            {onDelete !== undefined && (
              <Button
                title={translate('button_delete')}
                containerStyle={styles.button.primaryContainer}
                buttonStyle={styles.button.primary}
                disabledStyle={styles.button.primaryDisabled}
                titleStyle={styles.button.primaryTitle}
                disabledTitleStyle={styles.button.primaryTitleDisabled}
                onPress={this.handleDelete}
                disabled={!isValid || isSubmitting}
                loading={isSubmitting}
                loadingProps={{ size: 'small', color: 'white' }}
              />
            )}
            {hasIssues ? (
              <Button
                title={translate('button_save')}
                containerStyle={styles.button.primaryContainer}
                buttonStyle={styles.button.primary}
                disabledStyle={styles.button.primaryDisabled}
                titleStyle={styles.button.primaryTitle}
                disabledTitleStyle={styles.button.primaryTitleDisabled}
                onPress={handleSubmit}
                disabled={!isValid || isSubmitting}
                loading={isSubmitting}
                loadingProps={{ size: 'small', color: 'white' }}
              />
            ) : (
              <>
                <Button
                  title={translate('button_preview')}
                  containerStyle={styles.button.primaryContainer}
                  buttonStyle={styles.button.primary}
                  disabledStyle={styles.button.primaryDisabled}
                  titleStyle={styles.button.primaryTitle}
                  disabledTitleStyle={styles.button.primaryTitleDisabled}
                  onPress={() => this.handlePreview(values)}
                  disabled={!isValid || isSubmitting}
                  loading={isSubmitting}
                  loadingProps={{ size: 'small', color: 'white' }}
                />
                <Button
                  title={translate('button_publish')}
                  containerStyle={styles.button.primaryContainer}
                  buttonStyle={styles.button.primary}
                  disabledStyle={styles.button.primaryDisabled}
                  titleStyle={styles.button.primaryTitle}
                  disabledTitleStyle={styles.button.primaryTitleDisabled}
                  onPress={() => this.handlePublish(values)}
                  disabled={!isValid || isSubmitting}
                  loading={isSubmitting}
                  loadingProps={{ size: 'small', color: 'white' }}
                />
              </>
            )}
          </View>
          {isDeleting && (
            <Modal
              style={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                alignSelf: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'transparent',
                borderWidth: 0,
              }}
              transparent
              presentationStyle="overFullScreen"
              visible
            >
              <View
                style={{
                  flex: 1,
                  position: 'relative',
                  alignSelf: 'center',
                  alignItems: 'center',
                  alignContent: 'center',
                  justifyContent: 'center',
                }}
              >
                <View
                  style={{
                    position: 'relative',
                    alignSelf: 'center',
                    backgroundColor: 'white',
                    padding: 24,
                    paddingBottom: 12,
                    borderColor: styles.primaryColor,
                    borderWidth: 8,
                  }}
                >
                  <Text>{translate('app_delete_modal')}</Text>

                  <View
                    style={{
                      justifyContent: 'center',
                      flexDirection: 'row',
                      paddingTop: 24,
                    }}
                  >
                    <Button
                      title={translate('button_cancel')}
                      containerStyle={styles.button.secondaryContainer}
                      buttonStyle={styles.button.secondary}
                      disabledStyle={styles.button.secondaryDisabled}
                      titleStyle={styles.button.secondaryTitle}
                      disabledTitleStyle={styles.button.secondaryTitleDisabled}
                      onPress={() => { this.setState({ isDeleting: false }); }}
                    />
                    <Button
                      title={translate('button_delete')}
                      containerStyle={styles.button.primaryContainer}
                      buttonStyle={styles.button.primary}
                      disabledStyle={styles.button.primaryDisabled}
                      titleStyle={styles.button.primaryTitle}
                      disabledTitleStyle={styles.button.primaryTitleDisabled}
                      onPress={this.handleDeleteReal}
                      disabled={!isValid || isSubmitting}
                      loading={isSubmitting}
                      loadingProps={{ size: 'small', color: 'white' }}
                    />
                  </View>
                </View>
              </View>
            </Modal>
          )}
        </KeyboardAvoidingView>
      </>
    );
  };

  render() {
    const { app } = this.props;

    return (
      <Formik
        validateOnMount
        enableReinitialize
        initialValues={{
          app: app || {},
          issues: app.getIssues,
          promoted: app.data.promoted || false,
        }}
        onSubmit={(values, formikBag) => this.handleNext(values, formikBag)}
      // validationSchema={validationSchema}
      >
        {this.renderForm}
      </Formik>
    );
  }
}

PublisherAppFormReview.defaultProps = {
  onDelete: undefined,
};

PublisherAppFormReview.propTypes = {
  app: PropTypes.instanceOf(App).isRequired,
  onCancel: PropTypes.func.isRequired,
  onPageSwitch: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  onSave: PropTypes.func.isRequired,
  onSavePreview: PropTypes.func.isRequired,
  onSavePublish: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
  direction: PropTypes.string.isRequired,
};

export default PublisherAppFormReview;
